module.exports = __webpack_public_path__ + "img/Players.d42b568a.svg";